import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function NbfcProtectedRoute(){  

    const loginObj = useSelector(state => state.nbfcLoginReducer);
    const { loginResult } = loginObj;

    return loginResult?.access ? <Outlet/>:<Navigate to="/" />
}
